module.exports = __webpack_public_path__ + "static/media/nima.da4ee998.jpeg";